import firebaseConfig from './firebase_config'
var defaultExport={}

//FireBase - //Since version 6.0.0 , config is fetched from firebase_config.js - for easier setup
defaultExport.firebaseConfig = firebaseConfig.config;

//App setup
defaultExport.adminConfig = {
  "appName": "The Escape Way admin panel",
  "slogan":" 2022",
  "design":{
    "sidebarBg":"sidebar-1.jpg", //sidebar-1, sidebar-2, sidebar-3
    "dataActiveColor":"blue", //"purple | blue | green | orange | red | rose"
    "dataBackgroundColor":"white", // "white | black"
  },
  "showItemIDs": false,
  "allowedUsers": null, //If null, allow all users, else it should be array of allowd users
  "allowGoogleAuth":true, //Allowed users must contain list of allowed users in order to use google auth
  "allowRegistration":false, //Should there be register page
  "fieldBoxName": "Detalle",
  "maxNumberOfTableHeaders":5,
  "prefixForJoin":[""],
  "showSearchInTables":false,
  "methodOfInsertingNewObjects":"push", //timestamp (key+time) | push - use firebase keys
  "goDirectlyInTheInsertedNode":true,
  "urlSeparator":"+",
  "urlSeparatorFirestoreSubArray":"~",
  "googleMapsAPIKey":"AIzaSyB4czVuqOmhmcwTtX8f3SOv7oSlKn14Oa0",
  "fieldsTypes":{
    "photo":["photo","image", "5_imagen_fondo", "6_logo", "7_marker_mapa", "3_fondo", "03_fondo", "11_fondo_pista_1", "13_fondo_pista_2", "15_fondo_pista_respuesta"],
    "dateTime":["end","start"],
    "map":["map","latlng","7_localizacion", "localizacion","07_localizacion"],
    "textarea":["description","3_texto_inicio", "4_texto_fin", "5_texto_pregunta", "05_texto_pregunta", "10_pista", "10_pista_1", "12_pista_2", "14_pista_respuesta"],
    "html":["content"],
    "radio":["radio","radiotf","featured", "0_abierta", "9_ubicacion", "09_ubicacion"],
    "checkbox":["checkbox"],
    "dropdowns":["status","dropdowns", "2_tipo", "0_abierta", "11_visible", "02_tipo"],
    "file":["video", "image"],
    "rgbaColor":['rgba'],
    "hexColor":['color'],
    "relation":['collection_news','type','creator','group'],
    "iconmd":['icon'],
    "iconfa":['iconfa'],
    "iconti":['iconti'],
    "iconio":['iconio'],
  },
  "optionsForDateTime":[
    {"key":"end", "dateFormat":"YYYY-MM-DD" ,"timeFormat":true, "saveAs":"x","locale":"es"},
    {"key":"start", "dateFormat":"X" ,"timeFormat":"HH:mm", "saveAs":"x"},
  ],
  "optionsForSelect":[
      {"key":"dropdowns","options":["new","processing","rejected","completed"]},
      {"key":"checkbox","options":["Skopje","Belgrade","New York"]},
      {"key":"status","options":["just_created","confirmed","canceled"]},
      {"key":"radio","options":["no","maybe","yes"]},
      {"key":"radiotf","options":["true","false"]},
      {"key":"featured","options":["true","false"]},
      {"key": "2_tipo", "options":["formulario", "qr", "foto"]},
      {"key": "02_tipo", "options":["formulario", "qr", "foto"]},
      {"key": "0_abierta", "options":["si","no"]},
      {"key": "11_visible", "options":["si","no"]},
      {"key": "9_ubicacion", "options":["si","no"]},
      {"key": "09_ubicacion", "options":["si","no"]},
  ],
  "optionsForRelation":[
      {
        //Firestore - Native
        "display": "name",
        "isValuePath": true,
        "key": "creator",
        "path": "/users",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "type_eventid",
        "value": "name"
      },
      {
        //Firestore - Native
        "display": "group",
        "isValuePath": true,
        "key": "group",
        "path": "/groups",
        "produceRelationKey": false,
        "relationJoiner": "-",
        "relationKey": "group_eventid",
        "value": "name"
      },
      {
        //Firebase - Mimic function
        "display":"name",
        "key":"eventtype",
        "path":"",
        "isValuePath":false,
        "value":"name",
        "produceRelationKey":true,
        "relationJoiner":"-",
        "relationKey":"type_eventid"
      }
  ],
  "paging":{
    "pageSize": 20,
    "finite": true,
    "retainLastPage": false
  },
  "hiddenKeys":["id", "Id", "email", "version", "Version", "Device", "device"],
  "previewOnlyKeys":["email","anotherPreviewOnlyKey"],
}

//Navigation
defaultExport.navigation = [
    {
      "link": "/",
      "name": "Dashboard",
      "schema":null,
      "icon":"home",
      "path": "",
       isIndex:true,
    },
    {
      "link": "firestoreadmin",
      "name": "Usuarios",
      "icon":"account_circle",
      "path": "usuarios",
      "tableFields":["email"]
    },
    {
      "link": "firestoreadmin",
      "name": "Actividades",
      "icon":"directions_run",
      "path": "actividades",
      "tableFields":["6_logo", "1_nombre", "2_preguntas"],
      isIndex:true,
    }
    /*,
    {
      "link": "push",
      "path": "",
      "name": "Push notification",
      "icon":"speaker_notes",
      "tableFields":[],
    }*/
  ];

  //From v 5.1.0 we suggest remoteSetup due to security
  //
defaultExport.pushSettings = {
  "remoteSetup":false,
  "remotePath":"pushSettings",
  "pushType":"expo", //firebase -  onesignal - expo
  "Firebase_AuthorizationPushKey":"AIzaSyCFUf7fspu61J9YsWE-2A-vI9of1ihtSiE", //Firebase push authorization key
  "pushTopic":"news", //Only for firebase push
  "oneSignal_REST_API_KEY":"",
  "oneSignal_APP_KEY":"",
  "included_segments":"Active Users", //Only for onesignal push
  "firebasePathToTokens":"/expoPushTokens", //we save expo push tokens in firebase db
  "saveNotificationInFireStore":true, //Should we store the notification in firestore
}

defaultExport.userDetails = {

}

defaultExport.remoteSetup = false;
defaultExport.remotePath = "admins/mobidonia";
defaultExport.allowSubDomainControl = false;
defaultExport.subDomainControlHolder = "admins/";
defaultExport.isAppCreator = false;
defaultExport.appEditPath = undefined;

export default defaultExport;


// WEBPACK FOOTER //
// ./src/config/app.js